/**
 * Transform Shopify Subscriptions widget into a simple button
 * Hides one-time purchase and creates custom subscription button
 */

console.log('🔧 subscription-widget-init.js is loading...');

(function() {
  'use strict';
  
  console.log('✅ subscription-widget-init.js initialized');
  
  function transformSubscriptionWidget() {
    console.log('🔍 Looking for subscription widget...');
    
    // Wait for the widget to load
    let attempts = 0;
    const maxAttempts = 50;
    
    const checkWidget = setInterval(function() {
      attempts++;
      
      // Look for Shopify Subscriptions widget (not Recharge)
      const subscriptionRadio = document.querySelector('input[data-radio-type="selling_plan"]');
      const onetimeRadio = document.querySelector('input[data-radio-type="one_time_purchase"]');
      
      if (attempts >= maxAttempts) {
        clearInterval(checkWidget);
        console.log('❌ Subscription widget not found after 5 seconds');
        return;
      }
      
      if (subscriptionRadio) {
        clearInterval(checkWidget);
        
        console.log('✅ Subscription widget found!');
        console.log('📍 Subscription radio:', subscriptionRadio);
        console.log('📍 One-time radio:', onetimeRadio);
        
        // 1. Hide one-time purchase completely
        if (onetimeRadio) {
          const onetimeWrapper = onetimeRadio.closest('.shopify_subscriptions_purchase_option_wrapper');
          if (onetimeWrapper) {
            onetimeWrapper.style.display = 'none';
            console.log('✅ One-time purchase hidden');
          }
        }
        
        // 2. Auto-select subscription
        subscriptionRadio.checked = true;
        subscriptionRadio.dispatchEvent(new Event('change', { bubbles: true }));
        console.log('✅ Subscription auto-selected');
        
        // 3. Hide subscription radio button and label text
        subscriptionRadio.style.display = 'none';
        const subscriptionLi = subscriptionRadio.closest('li');
        if (subscriptionLi) {
          subscriptionLi.style.display = 'none';
        }
        
        // 4. Get widget container
        const widgetBlock = document.querySelector('.shopify_subscriptions_app_block');
        console.log('📍 Widget block:', widgetBlock);
        
        // 5. Get price from subscription
        const priceText = subscriptionRadio.getAttribute('data-variant-price') || '€63,00 EUR';
        console.log('💰 Price found:', priceText);
        
        // 6. Hide the entire subscription options display
        const fieldset = document.querySelector('.shopify_subscriptions_fieldset > div');
        if (fieldset) {
          fieldset.style.display = 'none';
          console.log('✅ Subscription widget hidden');
        }
        
        // 7. Get selling plan ID from subscription radio
        const sellingPlanId = subscriptionRadio.value || subscriptionRadio.getAttribute('data-selling-plan-id');
        console.log('🆔 Selling plan ID:', sellingPlanId);
        
        // 8. Créer le sélecteur de fréquence
        const frequencySelector = new VinpopFrequencySelector();
        const frequencySelectorElement = frequencySelector.createSelector();
        
        // 9. Créer le bouton d'abonnement personnalisé
        const customButton = document.createElement('button');
        customButton.type = 'submit';
        customButton.name = 'selling_plan';
        customButton.value = sellingPlanId;
        customButton.className = 'btn product-form__cart-submit vinpop-subscribe-button';
        
        // Texte basé sur la langue détectée
        const htmlLang = document.documentElement.lang;
        const buttonText = htmlLang === 'nl' ? 'Abonneren en besparen 10%' : 'Subscribe and Save 10%';
        customButton.innerHTML = `${buttonText} - ${priceText}`;
        
        // Style du bouton
        customButton.style.cssText = `
          background: #ffcc37 !important;
          color: #000000 !important;
          border-radius: 0.5rem !important;
          padding: 1rem 1.5rem !important;
          font-weight: 600 !important;
          border: 2px solid #000 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          box-shadow: 4px 4px 0px 0px #000 !important;
          margin-top: 1rem !important;
          width: 100% !important;
          text-align: center !important;
        `;
        
        // 10. Add click handler
        customButton.addEventListener('click', function(e) {
          e.preventDefault();
          console.log('🖱️ Subscription button clicked');
          
          // Get selected frequency
          const frequency = frequencySelector.getSelectedFrequency();
          console.log('📅 Selected frequency:', frequency);
          
          // Ensure subscription is selected
          subscriptionRadio.checked = true;
          subscriptionRadio.dispatchEvent(new Event('change', { bubbles: true }));
          
          // Add frequency data to form if needed
          const form = customButton.closest('form');
          if (form && frequency.value) {
            let frequencyInput = form.querySelector('input[name="properties[delivery_frequency]"]');
            if (!frequencyInput) {
              frequencyInput = document.createElement('input');
              frequencyInput.type = 'hidden';
              frequencyInput.name = 'properties[delivery_frequency]';
              form.appendChild(frequencyInput);
            }
            frequencyInput.value = frequency.value;
            console.log('📝 Added frequency to form:', frequency.value);
          }
          
          // Click add to cart
          const addToCartBtn = document.querySelector('button[type="submit"][name="add"]') ||
                              document.querySelector('.add-to-cart-btn');
          if (addToCartBtn) {
            console.log('🛒 Clicking add to cart button');
            addToCartBtn.click();
          } else {
            console.log('❌ Add to cart button not found');
          }
        });
        
        // 11. Insert frequency selector and button in the card
        const paymentButtonsContainer = document.querySelector('.dynamic-payment-buttons');
        const addToCartButton = document.querySelector('.add-to-cart-btn');
        
        // Create a container for both frequency selector and button
        const subscriptionContainer = document.createElement('div');
        subscriptionContainer.className = 'vinpop-subscription-container';
        subscriptionContainer.appendChild(frequencySelectorElement);
        subscriptionContainer.appendChild(customButton);
        
        if (paymentButtonsContainer && paymentButtonsContainer.parentElement) {
          // Insert before the payment buttons container
          paymentButtonsContainer.parentElement.insertBefore(subscriptionContainer, paymentButtonsContainer);
          console.log('✅ Subscription container added before payment buttons');
        } else if (addToCartButton && addToCartButton.parentElement && addToCartButton.parentElement.parentElement) {
          // Fallback: Insert after add to cart button container
          const buttonWrapper = addToCartButton.parentElement.parentElement;
          buttonWrapper.appendChild(subscriptionContainer);
          console.log('✅ Subscription container added after add to cart');
        } else if (widgetBlock) {
          // Last resort: Insert after the widget
          widgetBlock.parentElement.insertBefore(subscriptionContainer, widgetBlock.nextSibling);
          console.log('✅ Subscription container added after widget block');
        }
        
        // 12. Hide auto-renews policy text
        const policyText = document.querySelector('.shopify_subscriptions_app_policy');
        if (policyText) {
          policyText.style.display = 'none';
          console.log('✅ Policy text hidden');
        }
        
        console.log('🎉 Subscription widget transformation complete with frequency selector!');
      }
    }, 100);
  }
  
  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', transformSubscriptionWidget);
  } else {
    setTimeout(transformSubscriptionWidget, 100);
  }
  
})();
